<script setup>
import ContentHeader from '@/Components/Content/Header/index.vue';
import Button from '@/Components/Button.vue';
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

const props = defineProps({
  scholarship: {
    type: Object,
    required: true,
  },
});

const page = usePage();
const context = computed(() => page.props?.context);

const showEnquiry = (context.value.enquiry_enabled ?? false) && (context.value.scholarship_enquiry_enabled ?? true);

const providerLogos = computed(() => {
  if(!props.scholarship.organisations.length) {
    return null;
  }

  return props.scholarship.organisations[0].logos;
});

const logoAltText = computed(() => {
  if(!props.scholarship.organisations.length) {
    return props.scholarship.name;
  }

  return props.scholarship.organisations[0].name;
});

const webAddress = computed(() => {
  let url = props.scholarship?.web_address
    ? props.scholarship.web_address
    : props.scholarship.organisations[0]?.web_address;
  if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
    url = 'https://' + url;
  }
  return url;
});
</script>

<template>
  <ContentHeader
    :image-set="providerLogos"
    :logo-alt-text="logoAltText"
  >
    <template #title>
      {{ scholarship.name }}
    </template>
    <template #subtitle>
      <a v-if="scholarship.organisations[0]" :href="`/provider/${scholarship.organisations[0].slug}/${scholarship.organisations[0].id}`">
        {{ scholarship.organisations[0].name }}
      </a>
    </template>
    <template #actions>
        <li v-if="showEnquiry" class="h-fit mb-0">
          <Button
            class="w-full"
            variant="primary"
            type="link"
            :aria-label="`Enquire about ${scholarship.name}`"
            :link="`/scholarship/${scholarship.slug}/${scholarship.id}/enquiry`"
          >
            Enquire
          </Button>
        </li>
        <li v-if="webAddress" class="h-fit mb-0">
          <Button
            class="w-full"
            variant="secondary"
            type="link"
            :link="webAddress"
            :external="true"
            :link-data="scholarship.organisations.length > 0 ? scholarship.organisations[0].name : null"
          >
            Visit website
          </Button>
        </li>
    </template>
  </ContentHeader>
</template>
